var _excluded = ["hideLabel", "className", "style"],
  _excluded2 = ["id", "label", "hideLabel", "errored", "className", "style", "dangerouslySetClassNames", "sizeVariant", "disabled", "noMargins"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { useAutoId } from "../../private/helpers";
import { VisuallyHiddenLabel } from "../Label";
import forwardRef from "../../private/forwardRef";
import { VisibleLabel, HiddenCheckbox, StyledCheckbox, CheckMarkSvg, Wrapper, CheckboxContainer } from "./styles";
var CheckboxLabel = _ref => {
  var {
      hideLabel,
      className,
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return hideLabel ? /*#__PURE__*/React.createElement(VisuallyHiddenLabel, props) : /*#__PURE__*/React.createElement(VisibleLabel, _extends({
    forwardedAs: "label",
    className: className,
    style: style
  }, props));
};
var CheckMark = _ref2 => {
  var {
    sizeVariant,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement(CheckMarkSvg, {
    $sizeVariant: sizeVariant,
    fill: "none",
    className: className,
    viewBox: sizeVariant === "small" ? "0 0 16 16" : "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: sizeVariant === "small" ? "M3.5 8L6.5 11L12.5 5" : "M6 12L10 16L18 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

/**
 * An input element that allows users to select one or more options.
 *
 * @see [Checkbox documentation](https://construct-kit.reainternal.net/components/web/core/checkbox)
 */
var Checkbox = forwardRef((_ref3, ref) => {
  var {
      id,
      label,
      hideLabel = false,
      errored = false,
      className,
      style,
      dangerouslySetClassNames,
      sizeVariant = "small",
      disabled = false,
      noMargins = false
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  var autoId = useAutoId(id);
  return /*#__PURE__*/React.createElement(Wrapper, {
    $disabled: disabled,
    $errored: errored,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(CheckboxContainer, {
    $sizeVariant: sizeVariant,
    $noMargins: noMargins,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkboxContainer
  }, /*#__PURE__*/React.createElement(HiddenCheckbox, _extends({
    id: autoId,
    $sizeVariant: sizeVariant,
    disabled: disabled,
    ref: ref,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.input
  }, props)), /*#__PURE__*/React.createElement(StyledCheckbox, {
    $errored: errored,
    $sizeVariant: sizeVariant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkbox
  }), /*#__PURE__*/React.createElement(CheckMark, {
    sizeVariant: sizeVariant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkmark
  })), /*#__PURE__*/React.createElement(CheckboxLabel, {
    htmlFor: autoId,
    hideLabel: hideLabel,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.label
  }, label));
});
Checkbox.displayName = "Checkbox";
export default Checkbox;